<template lang="html">
  <div id="footer">
     <div class="meio">
       <div style="clear: both;"><br/></div>

       <div class="end">
         <h4>Central de Atendimento</h4>
         <p>
           Av. 136, nº 797, 19º andar, salas 1901B a 1905B Ed, New York - Setor Sul<br>
           Goiânia - GO CEP: 74093-250
         </p>

         <strong>Telefones</strong>
         <p>0800 941 6601</p>
       </div>
       <div id="creditos">
         <div class="copy">&copy; {{ ano }} Soluti - Todos os direitos reservados
           <br/>
           v2.3.0
         </div>
       </div>

     </div>

  </div> <!-- footer -->

</template>

<script>
export default {
  data() {
    return {
      ano: new Date().getFullYear()
    }
  }
}
</script>

<style lang="css">
.rigth-column {
  float: right;
  padding-top: 10px;
}
.rigth-column img {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?15446916